export const RoundsReport = {
  report: "Reporte",
  reports: "Reportes",
  createReport: "Crear reporte",
  deleteReport: "Eliminar reporte",
  noReportsHaveBeenCreated:
    "No hay reportes creados, por favor crea un reporte antes de continuar.",
  pdfPreview: "Vista previa PDF",
  pleaseAddAssets: "Por favor, agrega uno o más assets para ver sus rondas.",
  totalRounds: "Total de rondas",
  noRoundsAvailable: "No hay rondas.",
  pleaseSelectAReport:
    "Por favor, selecciona un reporte de rondas o crea uno nuevo.",
  reportName: "Nombre del reporte",
  enterReportName: "Ingrese el nombre del reporte",
  reportDescription: "Descripción del reporte",
  enterReportDescription: "Ingrese una descripción para el reporte",
  round: "Ronda",
  rounds: "Rondas",
  generalConfig: "Configuración general",
  emailAddresses: "Direcciones de email",
  areYouSureYouWantToDelete:
    "¿Estás seguro de que deseas eliminar el reporte de rondas ",
  onceDeleted: "Una vez que se elimine este no podrá ser recuperado.",
  emailSendingTime: "Hora de envío de correos",
  minuteSelectionMustBe: "La selección de minutos debe ser un múltiplo de 30.",
  maximumImagesPerRound: "Máximo de imágenes por ronda",
  maximumTimeBetweenEvents: "Tiempo máximo entre eventos (minutos)",
  roundStartTime: "Hora inicio de rondas",
  roundEndTime: "Hora fin de rondas",
  linkedAssets: "Assets asociados",
  unlinkedAssets: "Assets no asociados",
  linkedUsers: "Usuarios asociados",
  unlinkedUsers: "Usuarios no asociados",
  emailInputError: "El email ingresado no es válido",
  sureToCancel: "¿Seguro que quieres cancelar?",
  sureToDelete: "¿Seguro que quieres eliminar este email?",
  oneOrMoreEmailsInvalid: "Uno o más de los emails ingresados no son válidos.",
  addOneOrMoreEmails: "Agregar uno o más emails (separados por comas).",
  inTotal: "en total.",
};
